<script>
  import Icon from "../Icon.svelte";
  import MenuItem from "./MenuItem.svelte";

  export let id;
  export let url;
  export let active = false;

  let clazz = "";
  export { clazz as class };

  export let haspopup = false;
  export let expanded = false;

  const desktopClassOverrides =
    "lg:!text-white lg:!text-size-12 lg:leading-6 lg:tracking-[0.3px] lg:hover:!bg-none lg:focus:!bg-none lg:focus:!ring-1";
  const desktopInnerClassOverrides = "lg:!px-8 lg:!py-2 lg:!bg-black";
</script>

<MenuItem
  {id}
  {url}
  {haspopup}
  {expanded}
  class="{desktopClassOverrides} {clazz}"
  innerClass={desktopInnerClassOverrides}
>
  <slot />

  <span class="lg:hidden">
    {#if active}
      <Icon type="confirm" class="bg-highlight rounded-full border-2 border-neutral-100" />
    {:else}
      <Icon type="chevron-right" />
    {/if}
  </span>
</MenuItem>
